export default __webpack_public_path__ + "static/media/3.bda37ea8.svg";